import {
  useGetService,
  type UseGetServiceOptions,
} from "@libs/service-providers/api-service-provider";

import { TICKETS_URL } from "./apiEndpoints";
import type { ApiResponse, TicketItem } from "./types";

type UseGetTicketsOptions = Omit<
  UseGetServiceOptions<ApiResponse<TicketItem[]>>,
  "route" | "queryKey"
>;

export const useGetTickets = (options?: UseGetTicketsOptions) =>
  useGetService<ApiResponse<TicketItem[]>>({
    route: `${TICKETS_URL}`,
    queryKey: ["dq-dashboard", "tickets"],
    retry: false,
    ...(options ?? {}),
  });
